/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_Placeholder_TaskInputs */

const cs_entity_picker_placeholder_task = /** @type {(inputs: Entity_Picker_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat úkol (název)`)
};

const en_entity_picker_placeholder_task = /** @type {(inputs: Entity_Picker_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search task (title)`)
};

/**
* | output |
* | --- |
* | "Search task (title)" |
*
* @param {Entity_Picker_Placeholder_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_placeholder_task = /** @type {((inputs?: Entity_Picker_Placeholder_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_Placeholder_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_placeholder_task(inputs)
	return cs_entity_picker_placeholder_task(inputs)
});